import React, { useState } from "react";

const FAQItem = ({ question, answer }) => {
  const [open, setOpen] = useState(false);
  const [hover, setHover] = useState(false);

  return (
    <div
      onClick={() => setOpen(!open)}
      style={{
        borderBottom: "1px solid #3a0a2a",
        padding: "18px 0",
        cursor: "pointer",
      }}
    >
      <h3
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        style={{
          color: hover || open ? "#ffffff" : "#FF6F91",
          fontSize: "18px",
          margin: 0,
          fontWeight: "500",
          transition: "color 0.25s ease",
        }}
      >
        {question}
      </h3>

      {open && (
        <p
          style={{
            color: "#d6b3c8",
            fontSize: "15px",
            lineHeight: "1.7",
            marginTop: "12px",
          }}
        >
          {answer}
        </p>
      )}
    </div>
  );
};

export default FAQItem;
